.cc{justify-content:flex-end;}